import {useState, useEffect, useRef, useCallback} from '@wordpress/element';
import {useCreditCardContext} from "./use-credit-card-context";

export const useCardFields = (
    {
        data,
        paypal,
        options
    }) => {

    const {
        cardFields,
        cardFieldRefs,
        setCardElement,
        setCardFields,
    } = useCreditCardContext();

    useEffect(() => {
        if (paypal && options) {
            const cardElement = paypal.CardFields(options);
            const name = cardElement.NameField(data.fields.name);
            const number = cardElement.NumberField(data.fields.number);
            const expiry = cardElement.ExpiryField(data.fields.expiry);
            const cvv = cardElement.CVVField(data.fields.cvv);

            setCardElement(cardElement);
            setCardFields({
                name,
                number,
                expiry,
                cvv
            })
        }
    }, [
        paypal,
        options
    ]);

    useEffect(() => {
        Object.keys(cardFields).map(key => {
            const field = cardFields[key];
            if (cardFieldRefs.current[key]) {
                field.render(cardFieldRefs.current[key]);
            }
        })
    }, [
        cardFields,
        cardFieldRefs
    ]);
}